module.exports = __webpack_public_path__ + "static/media/regles_firewall.356a8cf5.PNG";